import React, { memo } from "react";
import { Icon } from "@iconify/react";
import s from "../pages/Promotion.module.css";

const PromotionCard = ({
  promotion,
  onClick,
  title,
  getImg,
  makeSvgPlaceholder,
  bonusText,
  depositText,
}) => {
  const deposit = depositText(promotion);
  const bonus = bonusText(promotion);

  return (
    <button type="button" className={s.card} onClick={() => onClick?.(promotion)}>
      <span className={s.media}>
        <img
          src={getImg(promotion, 400, 400)}
          alt={title}
          loading="lazy"
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = makeSvgPlaceholder(400, 400);
          }}
        />
      </span>

      <span className={s.body}>
        <span className={s.title}>{title}</span>

        {(deposit || bonus) && (
          <span className={s.facts}>
            {deposit && (
              <span className={s.fact}>
                <Icon icon="solar:wallet-money-bold-duotone" width="16" height="16" />
                {deposit}
              </span>
            )}
            {bonus && (
              <span className={`${s.fact} ${s.factGold}`}>
                <Icon icon="solar:gift-bold-duotone" width="16" height="16" />
                {bonus}
              </span>
            )}
          </span>
        )}

        <span className={s.more}>
          ดูรายละเอียด
          <Icon icon="solar:alt-arrow-right-linear" width="14" height="14" />
        </span>
      </span>
    </button>
  );
};

export default memo(PromotionCard);
